import * as React from "react";

import BaseProductGroupListLayout from "./BaseProductGroupListLayout";
import ProductGroupEditPopup from "../containers/products/ProductGroupEditPopup";

export default function ({ groupId }) {
  return BaseProductGroupListLayout(<ProductGroupEditPopup groupId={groupId} />);
}
